export interface IJsonMetaData<T> {
  name?: string,
  classType?: { new(): T }
}

export const jsonMetadataKey = "jsonProperty";

export function JsonProperty<T>(metadata?: IJsonMetaData<T> | string): any {
  if(metadata instanceof String || typeof metadata==="string") {
    return Reflect.metadata(jsonMetadataKey, {
      name: metadata,
      classType: String
    });
  }
  else {
    let metadataObj = <IJsonMetaData<T>>metadata;
    return Reflect.metadata(jsonMetadataKey, {
      name: metadataObj ? metadataObj.name : undefined,
      classType: metadataObj ? metadataObj.classType : undefined
    });
  }
}